import { Pipe, PipeTransform } from '@angular/core';
import * as debug from 'debug';

/**
 * Generated class for the FormatPayTypePipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'formatPayType',
})
export class FormatPayTypePipe implements PipeTransform {
  log = debug('app:FormatPayTypePipe');

  /**
   * Takes a job and formats the payType data for the header of compensation
   * job cards
   *  NOTE: the spans returned are to format certain text in light grey per
   *        CDLLIFE's request
   */

  formatPrice = function(value) {
    let str = String(value).replace(/[^0-9.]/g, ''),
      d = Number(str) || 0,
      b = d < 0 ? '-$' : '$';

    return (
      '$' +
      d
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        .replace(/\.00$/, '')
    );
  };

  transform(job: any, ...args) {
    this.log('FormatPayTypePipe: ', job);
    let s = '';

    // Weekly -
    if (job.cardType !== 'description' && job.cardType !== 'xml') {
      if (job.payType === 'fixed') {
        s += job.payUpTo
          ? '<span class="Job-headerTimeframe">Up to </span>'
          : '';
        s += this.formatPrice(job.pay);
        s += job.payMaxPlus ? '+' : '';
        s += '<span class="Job-headerTimeframe"> per week</span>';
        return s;
      }
      // Weekly - Range
      else if (job.payType === 'range') {
        s += this.formatPrice(job.payMin);
        s += ' - ';
        s += this.formatPrice(job.payMax);
        s += job.payMaxPlus ? '+' : '';
        s += '<span class="Job-headerTimeframe"> per week</span>';
        return s;
      }
      // Monthly - Fixed
      else if (job.payType === 'monthlyFixed') {
        s += job.payUpTo
          ? '<span class="Job-headerTimeframe">Up to </span>'
          : '';
        s += this.formatPrice(job.pay);
        s += job.payMaxPlus ? '+' : '';
        s += '<span class="Job-headerTimeframe"> per month</span>';
        return s;
      }
      // Monthly - Range
      else if (job.payType === 'monthlyRange') {
        s += this.formatPrice(job.payMin);
        s += ' - ';
        s += this.formatPrice(job.payMax);
        s += job.payMaxPlus ? '+' : '';
        s += '<span class="Job-headerTimeframe"> per month</span>';
        return s;
      }
      // Annually - Fixed
      else if (job.payType === 'annuallyFixed') {
        s += job.payUpTo
          ? '<span class="Job-headerTimeframe">Up to </span>'
          : '';
        s += this.formatPrice(job.pay);
        s += job.payMaxPlus ? '+' : '';
        s += '<span class="Job-headerTimeframe"> per year</span>';
        return s;
      }
      // Annually - Range
      else if (job.payType === 'annuallyRange') {
        s += this.formatPrice(job.payMin);
        s += ' - ';
        s += this.formatPrice(job.payMax);
        s += job.payMaxPlus ? '+' : '';
        s += '<span class="Job-headerTimeframe"> per year</span>';
        return s;
      }
      // Click for details
      else if (job.payType === 'clickForDetails') {
        return 'Click for Details';
      }
      // Anything else - might catch some deprecated "custom" types
      else {
        return 'Click for Details';
      }
    } else {
      return 'Click for Details';
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/format-pay-type/format-pay-type.ts